function isCEFSharp() {
  return !!window.OverlayPluginApi;
}

export default isCEFSharp;
